import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "close-outline"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-close-outline',
    templateUrl: './icon-close-outline.component.html',
    styleUrls: ['./icon-close-outline.component.scss'],
    standalone: false
})
export class IconCloseOutlineComponent  {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
